import { Component, OnInit, Input } from '@angular/core';
import { EnvironmentSettings } from '../../models/environment-settings.model';
import { AccountService } from 'src/app/account/services/account.service';
import { catchError, take } from 'rxjs/operators';
import { Account } from 'src/app/order/models/account.model';
import { WorkshopSubcontractorsService } from 'src/app/workshop/services/workshop-subcontractors.service';
import { LABEL_SIZE_PRESETS, MAX_LABEL_MM, MIN_LABEL_MM, isLabelDimension } from 'src/app/warehousing/services/label-layout';

@Component({
    selector: 'app-environment-form',
    templateUrl: './environment-form.component.html',
    styleUrls: ['./environment-form.component.scss'],
    standalone: false
})
export class EnvironmentFormComponent implements OnInit {
  @Input()
  environment:EnvironmentSettings = new EnvironmentSettings();

  depots: any = [];

  readonly labelSizePresets = LABEL_SIZE_PRESETS;
  readonly minLabelMm = MIN_LABEL_MM;
  readonly maxLabelMm = MAX_LABEL_MM;

  /** Set when the operator picks Custom, so the size boxes stay open on a preset size. */
  private customLabelSize = false;

  constructor(
    private accountService:AccountService,
    private workshopService: WorkshopSubcontractorsService
  ) { }

  ngOnInit(): void {
    this.accountService.getAllDepots()
    .pipe(catchError((e)=>{alert('Could not get Depots');return e;}))
    .pipe(take(1))
    .subscribe(depots => {
      this.depots = depots;
    })
  }

  /** Index of the preset matching the current label size, or 'custom'. */
  getLabelPreset(): string {
    if(this.customLabelSize) {
      return 'custom';
    }

    const index = this.labelSizePresets.findIndex(p =>
      p.widthMm === Number(this.environment.labelWidthMm) && p.heightMm === Number(this.environment.labelHeightMm));

    return index === -1 ? 'custom' : String(index);
  }

  onLabelPresetChanged(value: string): void {
    if(value === 'custom') {
      this.customLabelSize = true;
      return;
    }

    const preset = this.labelSizePresets[+value];
    this.customLabelSize = false;
    this.environment.labelWidthMm = preset.widthMm;
    this.environment.labelHeightMm = preset.heightMm;
  }

  isLabelDimensionValid(mm: any): boolean {
    return isLabelDimension(Number(mm));
  }
}
